import axiosClient from '../../configs/axios';


class UomMasterService {
    // Get list 
    async getUOMList(params) {
        try {
            const response = await axiosClient.get(
                `/uom/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addUOM(data) {
        try {
            const response = await axiosClient.post('/uom/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteUOM(data) {
        try {
            const response = await axiosClient.put(`/uom/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new UomMasterService(); 